const actions = {
  CREATE_MEMBER_POINT_TYPE: 'CREATE_MEMBERPOINT_TYPE',
  CREATE_MEMBER_POINT_TYPE_ENDED: 'CREATE_MEMBERPOINT_TYPE_ENDED',
  CREATE_MEMBER_POINT_THIRD_PARTY_TYPE: 'CREATE_MEMBER_POINT_THIRD_PARTY_TYPE',
  CREATE_MEMBER_POINT_THIRD_PARTY_TYPE_ENDED: 'CREATE_MEMBER_POINT_THIRD_PARTY_TYPE_ENDED',
  CREATE_MEMBER_POINT_ALLOCATION_RULE: 'CREATE_MEMBER_POINT_ALLOCATION_RULE',
  CREATE_MEMBER_POINT_ALLOCATION_RULE_ENDED: 'CREATE_MEMBER_POINT_ALLOCATION_RULE_ENDED',
  CREATE_MEMBER_POINT_DEDUCTION_RULE: 'CREATE_MEMBER_POINT_DEDUCTION_RULE',
  CREATE_MEMBER_POINT_DEDUCTION_RULE_ENDED: 'CREATE_MEMBER_POINT_DEDUCTION_RULE_ENDED',
  CREATE_MEMBER_POINT_EXCHANGE: 'CREATE_MEMBER_POINT_EXCHANGE',
  CREATE_MEMBER_POINT_EXCHANGE_ENDED: 'CREATE_MEMBER_POINT_EXCHANGE_ENDED',
  SEARCH_MEMBER_POINT_TYPES: 'SEARCH_MEMBER_POINT_TYPES',
  SEARCH_MEMBER_POINT_TYPES_ENDED: 'SEARCH_MEMBER_POINT_TYPES_ENDED',
  SEARCH_MEMBER_POINT_THIRD_PARTY_TYPES: 'SEARCH_MEMBER_POINT_THIRD_PARTY_TYPES',
  SEARCH_MEMBER_POINT_THIRD_PARTY_TYPES_ENDED: 'SEARCH_MEMBER_POINT_THIRD_PARTY_TYPES_ENDED',
  SEARCH_MEMBER_POINT_ALLOCATION_RULES: 'SEARCH_MEMBER_POINT_ALLOCATION_RULE',
  SEARCH_MEMBER_POINT_ALLOCATION_RULES_ENDED: 'SEARCH_MEMBER_POINT_ALLOCATION_RULES_ENDED',
  SEARCH_MEMBER_POINT_DEDUCTION_RULES: 'SEARCH_MEMBER_POINT_DEDUCTION_RULES',
  SEARCH_MEMBER_POINT_DEDUCTION_RULES_ENDED: 'SEARCH_MEMBER_POINT_DEDUCTION_RULES_ENDED',
  SEARCH_MEMBER_POINT_TRANSACTION_RECORDS: 'SEARCH_MEMBER_POINT_TRANSACTION_RECORDS',
  SEARCH_MEMBER_POINT_TRANSACTION_RECORDS_ENDED: 'SEARCH_MEMBER_POINT_TRANSACTION_RECORDS_ENDED',
  SEARCH_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORDS:
    'SEARCH_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORDS',
  SEARCH_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORDS_ENDED:
    'SEARCH_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORDS_ENDED',
  SEARCH_MEMBER_POINT_EXCHANGE: 'SEARCH_MEMBER_POINT_EXCHANGE',
  SEARCH_MEMBER_POINT_EXCHANGE_ENDED: 'SEARCH_MEMBER_POINT_EXCHANGE_ENDED',
  FIND_MEMBER_POINT_TRANSACTION_RECORD: 'FIND_MEMBER_POINT_TRANSACTION_RECORD',
  FIND_MEMBER_POINT_TRANSACTION_RECORD_ENDED: 'FIND_MEMBER_POINT_TRANSACTION_RECORD_ENDED',
  FIND_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORD:
    'FIND_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORD',
  FIND_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORD_ENDED:
    'FIND_MEMBER_THIRD_PARTY_POINT_TRANSACTION_RECORD_ENDED',
  GET_ENABLED_MEMBER_POINT_TYPES: 'GET_ENABLED_MEMBER_POINT_TYPES',
  GET_ENABLED_MEMBER_POINT_TYPES_ENDED: 'GET_ENABLED_MEMBER_POINT_TYPES_ENDED',
  GET_ENABLED_MEMBER_POINT_THIRD_PARTY_TYPES: 'GET_ENABLED_MEMBER_POINT_THIRD_PARTY_TYPES',
  GET_ENABLED_MEMBER_POINT_THIRD_PARTY_TYPES_ENDED:
    'GET_ENABLED_MEMBER_POINT_THIRD_PARTY_TYPES_ENDED',
  FIND_MEMBER_POINT_ALLOCATION_RULE: 'FIND_MEMBER_POINT_ALLOCATION_RULE',
  FIND_MEMBER_POINT_ALLOCATION_RULE_ENDED: 'FIND_MEMBER_POINT_ALLOCATION_RULE_ENDED',
  UPDATE_MEMBER_POINT_TYPE: 'UPDATE_MEMBER_POINT_TYPE',
  UPDATE_MEMBER_POINT_TYPE_ENDED: 'UPDATE_MEMBER_POINT_TYPE_ENDED',
  UPDATE_MEMBER_POINT_THIRD_PARTY_TYPE: 'UPDATE_MEMBER_POINT_THIRD_PARTY_TYPE',
  UPDATE_MEMBER_POINT_THIRD_PARTY_TYPE_ENDED: 'UPDATE_MEMBER_POINT_THIRD_PARTY_TYPE_ENDED',
  UPDATE_MEMBER_POINT_ALLOCATION_RULE: 'UPDATE_MEMBER_POINT_ALLOCATION_RULE',
  UPDATE_MEMBER_POINT_ALLOCATION_RULE_ENDED: 'UPDATE_MEMBER_POINT_ALLOCATION_RULE_ENDED',
  UPDATE_MEMBER_POINT_DEDUCTION_RULE: 'UPDATE_MEMBER_POINT_DEDUCTION_RULE',
  UPDATE_MEMBER_POINT_DEDUCTION_RULE_ENDED: 'UPDATE_MEMBER_POINT_DEDUCTION_RULE_ENDED',
  UPDATE_MEMBER_POINT_EXCHANGE: 'UPDATE_MEMBER_POINT_EXCHANGE',
  UPDATE_MEMBER_POINT_EXCHANGE_ENDED: 'UPDATE_MEMBER_POINT_EXCHANGE_ENDED',
  DELETE_MEMBER_POINT_TYPES: 'DELETE_MEMBERPOINT_TYPES',
  DELETE_MEMBER_POINT_TYPES_ENDED: 'DELETE_MEMBERPOINT_TYPES_ENDED',
  DELETE_MEMBER_POINT_THIRD_PARTY_TYPES: 'DELETE_MEMBER_POINT_THIRD_PARTY_TYPES',
  DELETE_MEMBER_POINT_THIRD_PARTY_TYPES_ENDED: 'DELETE_MEMBER_POINT_THIRD_PARTY_TYPES_ENDED',
  DELETE_MEMBER_POINT_ALLOCATION_RULES: 'DELETE_MEMBER_POINT_ALLOCATION_RULES',
  DELETE_MEMBER_POINT_ALLOCATION_RULES_ENDED: 'DELETE_MEMBER_POINT_ALLOCATION_RULES_ENDED',
  DELETE_MEMBER_POINT_DEDUCTION_RULES: 'DELETE_MEMBER_POINT_DEDUCTION_RULES',
  DELETE_MEMBER_POINT_DEDUCTION_RULES_ENDED: 'DELETE_MEMBER_POINT_DEDUCTION_RULES_ENDED',
  DELETE_MEMBER_POINT_EXCHANGE: 'DELETE_MEMBER_POINT_EXCHANGE',
  DELETE_MEMBER_POINT_EXCHANGE_ENDED: 'DELETE_MEMBER_POINT_EXCHANGE_ENDED',
  ALLOCATE_POINTS_TO_MEMBER: 'ALLOCATE_POINTS_TO_MEMBER',
  ALLOCATE_POINTS_TO_MEMBER_ENDED: 'ALLOCATE_POINTS_TO_MEMBER_ENDED',
  DEDUCT_POINTS_FROM_MEMBER: 'DEDUCT_POINTS_FROM_MEMBER',
  DEDUCT_POINTS_FROM_MEMBER_ENDED: 'DEDUCT_POINTS_FROM_MEMBER_ENDED',
  DEDUCT_POINTS_FOR_DISCOUNT_FROM_MEMBER: 'DEDUCT_POINTS_FOR_DISCOUNT_FROM_MEMBER',
  DEDUCT_POINTS_FOR_DISCOUNT_FROM_MEMBER_ENDED: 'DEDUCT_POINTS_FOR_DISCOUNT_FROM_MEMBER_ENDED',
  COPY_MEMBER_POINT_ALLOCATION_RULE: 'COPY_MEMBER_POINT_ALLOCATION_RULE',
  COPY_MEMBER_POINT_ALLOCATION_RULE_END: 'COPY_MEMBER_POINT_ALLOCATION_RULE_END',
  ARCHIVE_ALL_MEMBER_POINT_ALLOCATION_RULES: 'ARCHIVE_ALL_MEMBER_POINT_ALLOCATION_RULES',
  ARCHIVE_ALL_MEMBER_POINT_ALLOCATION_RULES_END: 'ARCHIVE_ALL_MEMBER_POINT_ALLOCATION_RULES_END',
};
export default actions;
